import ApiClient from './apiClient'
import {
  RequestCompare,
  RequestMemberReportList,
  RequestReport,
  RequestReportList,
  RequestTeamReportList,
  RequestTeamSort,
  ResponseCompare,
  ResponseMemberReportList,
  ResponseMonthlyMemberReport,
  ResponseReportList,
  ResponseTeamReportList,
} from '../types/report'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getReportList = async (params: RequestReportList): Promise<any> => ApiClient.get(
  `/api/report/list`,
  (result: ResponseReportList) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMemberReportList = async (params: RequestMemberReportList): Promise<any> => ApiClient.get(
  `/api/report/list/member`,
  (result: ResponseMemberReportList) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTeamReportList = async (params: RequestTeamReportList): Promise<any> => ApiClient.get(
  `/api/report/list/team`,
  (result: ResponseTeamReportList) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMonthlyMemberReport = async (id: number, params: RequestReport): Promise<any> => ApiClient.get(
  `/api/report/monthly/member/${id}`,
  (result: ResponseMonthlyMemberReport) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMonthlyTeamReport = async (id: number, params: RequestReport): Promise<any> => ApiClient.get(
  `/api/report/monthly/team/${id}`,
  (result: ResponseMonthlyMemberReport) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWeeklyMemberReport = async (id: number, params: RequestReport): Promise<any> => ApiClient.get(
  `/api/report/weekly/member/${id}`,
  (result: ResponseMonthlyMemberReport) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getWeeklyTeamReport = async (id: number, params: RequestReport): Promise<any> => ApiClient.get(
  `/api/report/weekly/team/${id}`,
  (result: ResponseMonthlyMemberReport) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCompare = async (params: RequestCompare): Promise<any> => ApiClient.get(
  `/api/report/compare`,
  (result: ResponseCompare) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const patchTeamOrder = async (params: RequestTeamSort): Promise<any> => ApiClient.patch(
  `/api/report/list/team_order`,
  () => {
    // do nothing
  },
  params,
)
